// extracted by mini-css-extract-plugin
export default {"tooltip":"zS-z","arrow":"AS-z"};